/** Pages that open while the plan is locked: reading, paying, the binder, the export (on /billing), switching business, and
 * (never wall safety) the health check-in and Report a problem. Its own file so the app shell can ask without loading the
 * lock screen (components/PlanGate.tsx loads on demand; the main chunk's budget, test/bundle-size.test.ts). */
export function lockedPathOk(path: string): boolean {
  return /^\/(billing(\/.*)?|prove|me|workspaces|activity(\/.*)?|check-in|report)\/?$/.test(path);
}
